import { render, staticRenderFns } from "./CustomBarChart.vue?vue&type=template&id=512e82e5&scoped=true&"
import script from "./CustomBarChart.vue?vue&type=script&lang=js&"
export * from "./CustomBarChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomBarChart.vue?vue&type=style&index=0&id=512e82e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e82e5",
  null
  
)

export default component.exports